import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';
import { clearError } from '../redux/errorSlice';

// Configuración directa en código
const isProduction = true; // Cambiar manualmente según el entorno

const GlobalError = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { message, status, redirectTo } = useSelector((state) => state.error);

    useEffect(() => {
        let timer;
        
        if (message) {
            timer = setTimeout(() => {
                dispatch(clearError());
            }, 5000);
        }

        if (redirectTo) {
            navigate(redirectTo);
            dispatch(clearError());
        }

        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [message, redirectTo, navigate, dispatch]);

    // No mostrar errores en producción
    if (isProduction || !message) {
        return null;
    }

    return (
        <Alert
            variant="danger"
            onClose={() => dispatch(clearError())}
            dismissible
            style={{
                position: 'fixed',
                top: '10px',
                right: '10px',
                zIndex: 1050,
            }}
        >
            <strong>Error {status}: </strong> {message}
        </Alert>
    );
};

export default GlobalError;